var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndex10(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#index10_svg__clip0_491_2882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8a8 8 0 018-8h16v16a8 8 0 01-8 8H0V8z",
    fill: "#000",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22 9.148l-1.314.965v-1.41l1.314-.958h1.327V17H8.22V9.148zm8.144 5.186v-3.923c-.025-.927-.46-1.398-1.301-1.415-.847.017-1.278.488-1.295 1.415v3.923c.017.935.448 1.407 1.295 1.415.842-.008 1.276-.48 1.301-1.415zm-3.923.076V10.33c.009-.855.282-1.513.819-1.975a2.59 2.59 0 011.803-.685c.72 0 1.33.228 1.834.685.512.462.777 1.12.794 1.975v4.081c-.017.85-.282 1.507-.794 1.968-.503.457-1.115.69-1.834.698a2.641 2.641 0 01-1.803-.698c-.537-.461-.81-1.117-.819-1.968z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "index10_svg__clip0_491_2882"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgIndex10;